import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: () => import('../views/home')
    },
    {
      path: '/stop/down',
      name: 'home',
      component: () => import('../views/home')
    },
    {
      path: '/*',
      name: 'home',
      component: () => import('../views/home')
    },
  ],
  mode: 'history',
  // base: process.env.BASE_URL,
  // // 切换路由后滚动条置顶
  // scrollBehavior() {
  //   return {
  //     x: 0,
  //     y: 0
  //   }
  // }
})



// WEBPACK FOOTER //
// ./src/router/index.js